import { useRouteMatch } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

const AppHelmet = () => {
  const workflowMatch = useRouteMatch<{ dealNumber?: string }>('/workflow/:dealNumber?')
  const manageBackupMatch = useRouteMatch('/manage-backup')
  const decisionEditMatch = useRouteMatch<{ dealNumber?: string }>(
    '/workflow/:dealNumber/:decisionType/:decisionReason/:emailId/edit'
  )

  let title = 'Decision Page'

  if (manageBackupMatch) {
    title = 'Manage Backup'
  } else if (decisionEditMatch?.params?.dealNumber) {
    title = `Decision Edit Page - ${decisionEditMatch.params.dealNumber}`
  } else if (workflowMatch?.params?.dealNumber) {
    title = `Decision Page - ${workflowMatch.params.dealNumber}`
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta charSet="utf-8" />
      <link rel="apple-touch-icon" sizes="120x120" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
      <meta name="msapplication-TileColor" content="#da532c" />
      <meta name="theme-color" content="#000000" />
    </Helmet>
  )
}

export default AppHelmet
